<template>
  <div class="login_warp">
    <el-dialog
        title=""
        width="860px"
        top="0"
        :visible.sync="showConsult"
        :before-close="closeFun"
        :append-to-body="true"
        :show-close="false"
        :close-on-click-modal="false"
        :lock-scroll="true">
      <div class="dialog_warp">
        <div class="dialog_box">
          <div class="top">
            <div class="consult_title">在线咨询</div>
            <div class="consult_desc">在线咨询时间为周一至周五9:00-17:00</div>
          </div>

          <div class="middle" v-if="feedBacksC != null" v-for="feedBack in feedBacksC">
            <div class="consult_item right">
              <div class="consult_time">{{ feedBack.createTime }}</div>
              <div class="consult_text">
                {{ feedBack.content }}
              </div>
              <img class="consult_img" src="../../assets/image/avatar.png" alt="">
            </div>

            <div class="consult_item left">
              <div class="consult_time">{{ feedBack.updateTime }}</div>
              <div class="consult_text" style="padding-left: 40px;">
                {{ (feedBack.reply != null && feedBack.reply != '') ? feedBack.reply : "暂未有回复" }}
              </div>
              <img class="consult_img" src="../../assets/image/avatar.png" alt="">
            </div>
          </div>

          <div class="bottom">
            <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                v-model="textarea"
                resize="none">
            </el-input>

            <div class="send_btn" @click="feedback()">发送</div>
          </div>

          <div @click="closeFun()" class="dialog_close el-icon-close cspt"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getItemWithExpiry} from "@/store/localstoragewithexpire";
import request from "@/utils/request";
import {Message} from "element-ui";

export default {
  props: {
    showConsult: Boolean,
    close: Function,
    feedBacksC: Array,
    user: Object,
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: ''
      },
      selectId: 0,
      textarea: "",
      isIpLogin: 0,
      isPersonLogin: 0,
      isLoginStatus: 0,
    };
  },
  methods: {
    init() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user)
    },
    feedback() {
      let data = {
        "content": this.textarea,
        "userId": this.user.userId,
        "feedType": '咨询'
      }
      request({
        url: '/api/index/feedback',
        method: 'post',
        params: data
      }).then(res => {
        Message({
          message: '您的留言已收到，会尽快给您回复',
          type: 'success',
          duration: 2 * 1000
        })
        this.closeFun();
      })
    },
    selectMod(id_) {
      this.selectId = id_
      // switch (id_) {
      //   case 1:
      //     this.selectId = id_
      //     break;

      //   default:
      //     break;
      // }
    },
    closeFun() {
      this.selectId = 0
      this.close()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  background: transparent;
  box-shadow: none;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.dialog_warp {
  // position: absolute;
  width: 100%;
  height: 700px;
  background: slategray;
  // bottom: 0;
  // left: -403px;
  border-radius: 20px;
  // overflow: hidden;
  .dialog_box {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .dialog_close {
      position: absolute;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.32);
      top: -32px;
      right: -32px;
      color: #FF8294;
      z-index: 100;
      text-align: center;
      line-height: 32px;
      font-size: 20px;
    }

    .top {
      width: 100%;
      height: 100px;
      background: linear-gradient(345deg, #FF8294 80%, #FFD8DE 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 20px 20px 0 0;

      .consult_title {
        width: 212px;
        height: 32px;
        font-size: 16px;
        color: #333333;
        text-align: center;
        background: #ffffff;
        border-radius: 16px;
        line-height: 32px;
      }

      .consult_desc {
        font-size: 12px;
        color: #fff;
        margin-top: 8px;
      }
    }

    .middle {
      flex-grow: 1;
      padding: 12px 30px;
      box-sizing: border-box;
      background: #F3F5F7;

      .consult_item {
        position: relative;
        margin-bottom: 20px;

        .consult_img {
          position: absolute;
          top: -2px;
          right: -10px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .consult_text {
          font-size: 14px;
          color: #333333;
        }
      }

      .consult_item.left {
        .consult_img {
          left: -10px;
        }

        .consult_time {
          text-align: right;
        }

        .consult_text {
          font-size: 14px;
          color: #777777;
        }
      }

      .consult_time {
        font-size: 12px;
        color: #AAAAAA;
        padding: 0 10px;
        margin-bottom: 2px;
      }

      .consult_text {
        min-height: 78px;
        padding: 20px 24px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 10px;
      }
    }

    .bottom {
      width: 100%;
      flex-shrink: 0;
      height: 140px;
      background: #fff;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
      padding: 14px 20px 0;
      box-sizing: border-box;
      border-radius: 0 0 20px 20px;

      .send_btn {
        width: 76px;
        height: 30px;
        background: #FF8193;
        border-radius: 8px;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        color: #fff;
        margin-top: 10px;
      }
    }
  }
}
</style>